/**
 * Форматирует число, добавляя пробелы между тысячами
 * @example
 * formatNumber(6000) // "6 000"
 * formatNumber(1234567) // "1 234 567"
 */
export const formatNumber = (number: number | string): string => {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
};
